import type { IIconName } from "@icon";

export enum IProductKeyIconsVariantsEnum {
  Lighter = "lighter",
  Stroke = "stroke",
}

export enum IProductKeyIconsColorEnum {
  Primary = "primary",
  Secondary = "secondary",
  Gray = "gray",
  Blue = "blue",
  Orange = "orange",
  Red = "red",
  Green = "green",
  Yellow = "yellow",
  Purple = "purple",
  Pink = "pink",
  Sky = "sky",
}

export enum IProductKeyIconsSizeEnum {
  XSmall = "x-small",
  Small = "small",
  Medium = "medium",
  Large = "large",
  XLarge = "x-large",
  XXLarge = "2x-large",
}

export interface IProductKeyIconsProps {
  iconName: IIconName;
  variant?: IProductKeyIconsVariantsEnum;
  color?: IProductKeyIconsColorEnum;
  size?: IProductKeyIconsSizeEnum;
  disabled?: boolean;
}
